import React from "react";
import { Flex, Grid, Text } from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import { BsBagFill } from "react-icons/bs";
import { FaTicketAlt, FaUsersCog } from "react-icons/fa";
import { RiShoppingCart2Fill } from "react-icons/ri";

import SectionHeader from "../../components/SectionHeader";
import withNavElements from "../../components/withNavElements";
import DashboardCard from "./DashboardCard";

const DasboardPage = () => {
  return (
    <>
      <Helmet>
        <title>Dashboard - Skyshops</title>
      </Helmet>
      <Flex
        flex={1}
        minH="300px"
        h="100%"
        mt="70px"
        py="40px"
        px={{ base: 0, md: "20px" }}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Text fontSize="1.5em" fontWeight="400">
            Admin Dashboard
        </Text>
        <Flex
          mt="40px"
          w="100%"
          pt="50px"
          pb='80px'
          px={{ base: "40px", md: "40px" }}
          flex={1}
          minH="100%"
          bg="gray.100"
          borderRadius="10px"
          justifyContent="center"
          alignItems="center"
          flexDir={"column"}
        >
            <SectionHeader 
                title="Operaciones de Administración"
                description="Desde aquí puedes administrar los productos, tiendas y usuarios de la plataforma."
                justifyContent="center"
                alignItems="center"
                mb='0'
            />

            <Grid
                w="100%"
                flex={1}
                minH="100%"
                mt="40px"
                px={{ base: "40px", md: "40px" }}
                templateColumns={{ base: "1fr", md: "repeat(3, 1fr)", lg: "repeat(4, 1fr)" }}
                gap={6}
                justifyContent="space-between"
                alignItems="center"
            >
                <DashboardCard
                    icon={<FaUsersCog size='2.5rem' />}
                    title="Usuarios"
                    to="/admin/dashboard/users"
                />

                <DashboardCard
                    icon={<RiShoppingCart2Fill size='2.5rem' />}
                    title="Tiendas"
                    to="/admin/dashboard/stores"
                />

                <DashboardCard 
                    icon={<BsBagFill size='2.5rem' />}
                    title="Productos"
                    to="/admin/dashboard/products"
                />

                <DashboardCard
                    icon={<FaTicketAlt size='2.5rem' />}
                    title="Pedidos"
                    to="/admin/dashboard/orders"
                />
            </Grid>
        </Flex>
      </Flex>
    </>
  );
};

export default withNavElements(DasboardPage);
